import { Injectable } from '@angular/core';
import { WebApiService } from '../../web-api.service';
import { WebApiClient } from '../../web-api-client.service';
import { PageData, PageData2 } from 'src/app/shared/models/page-data';
import { H10 } from 'src/app/models/H10';
import { H11 } from 'src/app/models/H11';
import { ParameterSetDto } from './param-set-api';
import { H12 } from 'src/app/models/H12';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { RatingPrice } from 'src/app/hist/rating-price/models/RatingPrice';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { HcrService } from '../../hcr-service.service';
import { UserCache } from '../../user-cache';

/** 申報人數統計Grid資料 DTO */
export class UserInfoDTO {
  Id: number;
  Name: string;
  MainDept: string;
  CId: string;
  IsRegular: boolean;
  PositionsName: string;
  PositionType: number;
  ArriveDate?: Date;
  LeaveDate?: Date;
  PositionCode: string;
}

/** 核對申報資料 查詢條件 DTO */
export class DeclareCheckQueryDTO {
  ClinicId: number
  Date: string;
  PageSize: number;
  PageNumber: number;
  QueryList: DeclareCheckFilterDTO[];
  GetDDL: boolean;
  AmendNum: string;
  OrderBy: string;
  OrderByDesc: boolean;
}

/** 核對申報資料 查詢條件類別 DTO */
export class DeclareCheckFilterDTO {
  Type: number
  Value: string;
  IsAmountFilter: boolean;
  extend: string;
}

/** 核對申報資料 View DTO */
export class DeclareChecViewDTO {
  /** 核對申報資料 PageData DTO */
  PageData: PageData2<DeclareCheckListDTO>;
  /** 案類 */
  CaseList: string[];
  /** 原案類-藥局用 */
  OrigCaseList: string[];
  /** 原機構-藥局用 */
  OrigNHICodeList: string[];
  /** 醫師 */
  DoctorList: string[];
  /** 藥師 */
  PharmList: string[];
  /** 調劑 */
  DispTPList: string[];
  /** 科別 */
  SubjectList: string[];
}

/** 門診申報xml DTO */
export class OPDxmlDataDTO {
  H10: H10
  H11List: H11[];
}

export class DeclareSampleReviewFilterDTO {
  Case: string;
  StartSeq: number;
  EndSeq: number;
  Step: number;
  Seq: string;
  DoctorCId: string;
  InternationalDxCode: string;
  SearchType: number;
  SearchKeyword: string;
  DrugFilter: number;
  DrugFee?: number;
}

export class DeclareSampleReviewRequestDTO {
  ClinicId: number;
  DeclareMonth: string;
  IncludeCC: boolean;
  CcFirst: boolean;
  IncludeVt: boolean;
  IncludeRemark: boolean;
  ConnectionId: string;
  RxName: number;
  AmendNum: string;
  SamplingType: number;
  CaseMode: 'A' | 'B';
  Filters: DeclareSampleReviewFilterDTO[];
  IncludeHistory: boolean;
  HistoryStart?: string;
  HistoryEnd?: string;
}

export class DeclareSampleReviewResultDTO {
  CurrentDeclareData: OPDxmlDataDTO[];
  DeclareData: OPDxmlDataDTO[];
  MatchedPatientIds: number[];
}

export interface PharComparisonDto {
  Id: number;
  RegDate: string;
  PatientNo: string;
  PatientCId: string;
  Isqno: string;
  CaseCode: string;
  CompareType: string;
  OriHosp: string;
  OriHospName: string;
  Message: string;
}

/** 參數設定+檢查申報H10,H11,H12 的Azure Table Stroage是否存在 DTO */
export class ParamSetAndCheckTableDto {
  /** 申報H10,H11,H12 的Azure Table Stroage是否存在 */
  IsTableExist: boolean
  /** 參數設定模型 */
  Parameter: ParameterSetDto;
  /** 該月份是否已有下載過xml (有xml Log) */
  HasXmlLog: boolean
}

/** 門診申報總表 報表 DTO */
export class OpdDeclareReportDTO {
  /** 總表段(H10) */
  H10: H10;
  /** 診所機構名稱 */
  ClinicName: string;
  /** 醫事機構地址 */
  ClinicAddress: string;
  /** 醫事機構電話 */
  ClinicPhone: string;
  /** 負責醫師姓名 */
  OwnerName: string;
  /** 醫療院所層級 */
  NHILevel: string;
  /** 1.西醫 2.牙醫 3.中醫 */
  CheckMedicine: number;
}
export interface DeclareCheckListDTO extends H11 {
  /** H12 醫令清單段 */
  H12List: H12[];
  /** 原醫令 */
  HRXList: HistOrder[];
  /** 原主訴-CC */
  CC: string;
  /** 原主訴-PE */
  PE: string;
  RuleRemark?: string;
  useExtraOnly?: boolean;
  classes?: string;
  /** 原批價*/
  OrigDeclare: RatingPrice[]
}

/** 申報案類統計-分頁(醫師分頁才會多筆，否則目前只有一筆) 報表 DTO */
export class DeclareCaseReportPageDTO {
  /** 月份 */
  Month: string;
  /** 醫師代號(身分證) */
  DrID: string;
  /** 醫師姓名 */
  DrName: string;
  /** 每頁統計明細 */
  Detail: DeclareCaseReportDTO[];
}
/** 申報案類統計-By案類 報表 DTO */
export class DeclareCaseReportDTO {
  /** 月份 */
  Month: string;
  /** 案件分類 */
  e11cs: string;
  /** 各保別-明細 */
  Detail: DeclareCaseReportDetailDTO[];
  /** 小計明細 */
  Subtotal: DeclareCaseReportDetailDTO;
}
/** 申報案類統計-明細 報表 DTO */
export class DeclareCaseReportDetailDTO {
  /** 保別-代碼 */
  ICode: string;
  /** 保別-名稱 */
  ICodeName: string;
  //#region  3L  (NHIDeclare)
  /** 診察費 */
  ADx: number;
  /** 內服藥費 */
  ARx2: number;
  /** 外用藥費 */
  ARx3: number;
  /** 注射費 */
  ARx4: number;
  /** 注射技術費 */
  ATx5: number;
  /** 檢查費 */
  ATx6: number;
  /** 放射費 */
  ATx7: number;
  /** 復健費 */
  ATx8: number;
  /** 處置費 */
  ATx9: number;
  /** 手術費 */
  ATx10: number;
  /** 麻醉費 */
  ATx11: number;
  /** 特材費 */
  AMat: number;
  /** 輸血費 */
  ATx13: number;
  /** 透析費 */
  ATx14: number;
  /** 病房費 */
  ATx15: number;
  /** 管灌費 */
  ATx16: number;
  /** 嬰兒費 */
  ATx17: number;
  /** 精療費 */
  ATx18: number;
  /** 藥事費 */
  AMed: number;
  /** 自費總額(真的自費，非健保欄位) */
  AOwn: number;
  /** 申請總額*/
  ADcl: number;
  /** 健保總額*/
  ATot: number;
  /** 其他費1*/
  Aother1: number;
  /** 其他費2*/
  Aother2: number;
  //#endregion
  //#region  申報H11檔
  /** 申報月份 */
  e11ym: string;
  /** 案件分類 */
  e11cs: string;
  /** 醫師代號 */
  DrID: string;

  /** 申請點數(d41) */
  e11ta: number;
  /** 部分負擔費用金額(d40) */
  e1198: number;
  /** 藥事服務費(d38) */
  e1199: number;
  /** 診察費(d36) */
  e11a1: number;
  /** 特殊材料明細點數小計(d34) */
  e11ab: number;
  /** 診療明細點數小計(d33) */
  e11a6: number;
  /** 用藥明細點數小計(d32) */
  e11a2: number;
  /** 合計點數(d39) */
  e11tt: number;
  //#endregion
  Count: number;
  RoomCode: string;
  Case: string;
  DoctorAccount: string;
  DoctorName: string;
}

/** 期間耗用量統計 查詢 DTO */
export class DeclarePeriodUsageQueryDTO {
  /** 開始日期 */
  StartDate: string;
  /** 結束日期 */
  EndDate: string;
  /** 是否包含醫令 */
  IncludeHRx: boolean;
  /** 是否包含其他收支 */
  IncludeOtherSales: boolean;
  /** 醫令代號 */
  RxCode: string;
  /** 健保代碼 */
  StdCode: string;
  /** 調劑方式 */
  DispType: string;
  /** 醫令歸屬 */
  NhiDrugType: number;
  /** 排序方式 */
  SortBy: string;
  /** 醫令費用統計方式 */
  ReportType: string;
}

/** 期間耗用量統計 報表 DTO */
export class DeclarePeriodUsageReportDTO {
  /** 藥品代碼 */
  RxCode: string;
  /** 健保碼 */
  StdCode: string;
  /** 商品名 */
  ProdName: string;
  /** 單位 */
  Unit: string;
  /** 使用數量 */
  Quantity: number;
  /** 健耗額(健保金額) */
  NHIAmount: number;
  /** 比率 */
  Ratio: number;
  /** 筆數 */
  MedCount: number;
}
/** 醫師用藥-分類統計 查詢 DTO */
export class DeclareRxCategoryQueryDTO {
  /** 開始日期 */
  StartDate: string;
  /** 結束日期 */
  EndDate: string;
  /** 醫令代號 */
  RxCode: string;
  /** 健保代碼 */
  StdCode: string;
  /** 調劑方式 */
  //DispType: string;
  /** 醫令歸屬（逗號分隔，空字串為全部） */
  NhiDrugTypes: string;
  /** 排序方式 */
  SortBy: string;
  /** 醫令費用統計方式 */
  ReportType: string;
   /** 診別代號 */
  RoomCode: string;
  /** 排除非健保藥（無健保碼） */
  ExcludeNonNhi?: boolean;
}

/** 醫師用藥-分類統計 報表 DTO */
export class DeclareRxCategoryReportDTO {
  /** 藥品代碼 */
  RxCode: string;
  /** 健保碼 */
  StdCode: string;
  /** 商品名 */
  ProdName: string;
  /** 歸屬 */
  NhiDrugType: number;
  /** 使用數量 */
  Quantity: number;
  /** 健耗額(健保金額) */
  NHIAmount: number;
   /** 健保上次價總額 */
  NHILastAmount: number;
  /** 健保單價 */
  NHIPrice: number;
  /** 健保上次價 */
  NHILastPrice: number;
  /** 藥品進價 */
  CustomerCost: number;
  /** 藥品進價總額 */
  CustomerCostAmount: number;
}


/** 就診比率與日均藥費統計 查詢 DTO */
export class GetVisitsRatioMedcostQueryDTO {
  /** 開始日期 */
  StartDate: string;
  /** 結束日期 */
  EndDate: string;
}

/** 就診比率與日均藥費統計 報表 DTO */
export class GetVisitsRatioMedcostReportDTO {
  /** 期間 */
  Duration: string;
  /** 人數 */
  NumOfPeople: number;
  /** 人次 */
  NumOfVisits: number;
  /** 就診比率 */
  VisitorRatio: number;
  /** 總藥費 */
  TotalMedCost: number;
  /** 總日份 */
  TotalDays: number;
  /** 日均藥費 */
  DailyMedCost: number;

}

/** 身心科期間平均治療費統計 查詢 DTO */
export class GetPeriodTreatFeeQueryDTO {
  /** 開始日期 */
  StartDate: string;
  /** 結束日期 */
  EndDate: string;
}

/** 身心科期間人均治療費統計 報表 DTO */
export class GetPeriodTreatFeeReportDTO {
  /** 期間 */
  Duration: string;
  /** 就診人次 */
  NumOfVisits: number;
  /** 看診天數 */
  NHIVisitDays: number;
  /** 總健保治療費 */
  TotalTreatFee: number;
  /** 人均健保治療費 */
  AvgTreatFee: number;

}

/** 健保申報明細摘要表 報表DTO */
export class OpdDeclareDetailsRptDTO {
  /** (d1)案件分類-代碼 */
  e11cs: string;
  /** (d1)案件分類-名稱 */
  e11csName: string;
  /** 每頁統計明細 */
  Detail: OpdDeclareDetailsRptSubDTO[];
  /** 合計 dto */
  Subtotal: OpdDeclareDetailsRptSubDTO;
}

/** 健保申報明細摘要表-明細 報表DTO */
export interface OpdDeclareDetailsRptSubDTO extends H11 {
  /** 診斷代碼1~5 */
  Dx: string;
  /** 診斷病名~5 */
  DxName: string;
  /** 醫令 */
  e12rx: string;
  /** 醫師 */
  Doctor: string;
}

/** 健保申報完整明細 資料 (代申報輔助使用) DTO */
export class OpdDeclareFullDetailsDTO {
  /** 每頁統計明細 */
  Detail: OpdDeclareFullDetailsSubDTO[];
  /** 合計 dto */
  Subtotal: OpdDeclareFullDetailsSubDTO;
}

/** 健保申報完整明細 資料 (代申報輔助使用)-明細 DTO */
export interface OpdDeclareFullDetailsSubDTO {
  H11: H11;
  /** (d1)案件分類-名稱 */
  e11csName: string;
  /** 醫令 */
  e12rx: string;
  /** 醫師名 */
  Doctor: string;
  /** 藥師名 */
  Pharm: string;
}


export class SameTreatPerMonthListDTO {
  /** 病歷號 */
  PatientNo: string;
  /** 姓名 */
  PatientName: string;
  /** 序 */
  SeqNo: string;
  /**  */
  CusNoPerMonth: number[][];

}

export declare type NHIDownloadRequestDTO = {
  ClinicIdAndType: string;
  TypeCode: string;
  Timestamp: string;
  Id: string;
  DeclareMonth: string;
  sNHI_ID: string;
  sLocal_ID: string;
  QueryFileName: string;
  sujestDownloadDate:string
  isDownload:boolean;
}

export declare type NHISendRequestDTO = {
  ClinicIdAndType: string;
  TypeCode: string;
  Timestamp: string;
  Id: string;
  Path: string;
  sNHI_ID: string;
  sLocal_ID: string;
  RequestTime: string;
}
/** 申報錯誤訊息，篩選類別Key */
export class DeclareMsgFilterKey {
  static readonly Warning = "▲警告";
  static readonly Error = "★錯誤";
  static readonly All = "";
}

export class AmendGridViewModel {
  Id: number = 0;
  PatientNo: string = '';
  PatientName: string = '';
  Isqno: string = '';
  Days: number = 0;
  RegDate: string = '';
  ICode: string = '';
  DispTP: string = '';
  Case: string = '';
  Pay: string = '';
  TP: string = '';
  Dept: string = '';
  CusNo: string = '';
  CntPresNo: string = '';

  checked: boolean = false;
}

/** 執行申報程式 QueryModel */
export class RunQuery {
  /** 診所Id */
  ClinicId: number;
  /** 申報月 */
  DeclareMonth: string;
  /** 申報方式：1書面 2媒體 3連線 */
  DeclareWay: string;
  /** 申報種類：1送核 2補報 */
  DeclareClass: string;
  /** 醫藥分業日 */
  MedDivSdate: string;
  /** 護理人員加計 */
  NursePlus: number;
  /** 超過X次警告 */
  OverTimes: number;
  /** 是否顯示 藥費+診療金額為零(E11A2、E11A6為0) 的警示 */
  IsZero: number;
  /** SignalR連線Id */
  ConnectionId: string;
  /** 若是補報要傳入第x次補報  " "代表一般申報  Y代表全部(機率低，但保留彈性，含這個月全部不管3L是否有補報Flag) */
  AmendNum: string;
  /** 補報原因 */
  AmendReason: string;
  /** 純注射設調劑6 (Y/N) */
  InjectDispTP: number;
  /** 列出未還單 (Y/N) */
  NoReturnList: number;
  /** 是否列出轉診名單(Y/N) */
  ShowReferralList: number;
  /** 是否將慢病09專案改04案類申報 (Y/N) */
  TranChronic4: number;
  /** 是否顯示慢病09專案警示訊息 (Y/N) */
  ShowTranChronic4: number;
  /** 牙醫 貴院所是否符合加強感染控制SOP(評分85分以上) */
  InfectionControlRatingPoints: number;
  /** 牙醫 貴院所是否符合加強感染控制SOP(偏遠醫療巡診) */
  InfectionControlRemoteMedical: number;
  /** 支援藥師遞補設定 */
  PartPharmacist: number;
  /** 專任藥師人數 */
  PharmacistNum: number;
  /** 中醫-是否有藥師(1聘有藥師 2中醫師親自調劑 3不申請調劑費) */
  ChinesePharmacist: number;
  /** 中醫-藥師請假調劑方式(1.依然申報調劑費(提醒無填入藥師) 2.中醫師親自調劑 3.不申請調劑費) */
  ChinesePhLeaveTP: number;
  /** 是否為院所自行決定申報給藥日份，若診所參數設定true，則依照3L的給藥日份為主 */
  DeclareFreeDay: boolean;
  /** 同療第2-6次有藥事費 (Y/N) */
  IsCusA99: number;
  /** 是否為更換醫事機構代號 */
  IsChangeNHICode: boolean;
  /** 本次申報的醫事機構代號(用於更換醫事機構代號時，要指定申報的) */
  SetNHICode: string;
  /** 藥局不符設立標準 [Y]門前藥局　[N]獨立藥局 */
  PharmType: number;
  /** 藥局-慢箋拿藥是否提示同人同月同卡序 (Y/N) */
  ShowPresSameMsg: number;
  /** 藥局-每日平均藥費上限警告-上限值 */
  A2FeeLimit: number;
  /** 新政令：不申報的卡序 格式：[卡序=政令開始日,卡序2=政令開始日2] */
  ExcludeIsqno: string;
  /** 牙醫-是否申報調劑費 */
  IsDentisitAMed: boolean;
  /** 山地離島地區實施計畫代碼 IDS計畫<d48> */
  MountainIDSCodeD48: string;
  /** 是否糖尿病團隊醫師有兼任護理師、營養師、藥師任一專業人員執行業務(Y/N) */
  DMteamDrMultipleRole: string;
}

/** 是否有同療併入本月 / 同療保留下月資料 DTO */
export class SameCusTPCheckDTO {
  /** 申報月 */
  DeclareMonth: Date;
  /** 是否有同療併入本月資料 */
  IntoCurrentMonth: boolean;
  /** 是否有同療保留下月資料 */
  HoldNextMonth: boolean;
}

/** 藥師調劑明細表 明細列 */
export interface PharmDispDetailDto {
  Date: string;
  Count: number;
  PatientNo: string;
  PatientName: string;
  DispFee: number;
  DrugFee: number;
  Days: number;
  DispType: string;
  /** 診治醫師 */
  Doctor: string;
}

/** 藥師調劑明細表 合計列 (每組內每日) */
export interface PharmDispSummaryDto {
  Date: string;
  Count: number;
  DispFee: number;
  DrugFee: number;
}

/** 藥師調劑明細表 明細(依藥師分組) */
export interface PharmDispDetailGroupDto {
  PharmacistCId: string;
  PharmacistName: string;
  Rows: PharmDispDetailDto[];
}

/** 藥師調劑明細表 合計(依藥師分組) */
export interface PharmDispSummaryGroupDto {
  PharmacistCId: string;
  PharmacistName: string;
  Rows: PharmDispSummaryDto[];
}

@Injectable({
  providedIn: 'root'
})
export class DeclareApi {
  api: WebApiService;
  constructor(
    private apiClient: WebApiClient, private hcrService: HcrService) {
    this.api = this.apiClient.createHisService('declares/Declare');
    this.api.enableLoader = true;
  }

  public async GetDoctors(): Promise<ValueTextPair[]> {
    var data = await this.api.get('GetDoctors').toPromise<ValueTextPair[]>();
    return data;
  }

  /** 取得各種醫事人員列表 */
  public async GetUserListForDeclare(clinicId: number, filter: string): Promise<UserInfoDTO[]> {
    var data = await this.api.get('GetUserListForDeclare', { clinicId: clinicId, filter: filter }).toPromise<UserInfoDTO[]>();
    return data;
  }

  /** 依照使用者職位取得使用者資訊清單 */
  public async GetUserPageListByPosition(clinicId: number, declareMonth: string, groupType: string, pageSize: number, pageNumber: number): Promise<PageData2<UserInfoDTO>> {
    var data = await this.api.get('GetUserPageListByPosition', {
      clinicId: clinicId,
      declareMonth: declareMonth,
      groupType: groupType,
      pageSize: pageSize,
      pageNumber: pageNumber
    }).toPromise<PageData2<UserInfoDTO>>();
    return data;
  }

  /** 執行申報程式 */
  public async Run(query: RunQuery): Promise<any> {
    return await this.api.post('Run', query).toPromise();
  }

  /** 取消申報背景作業並等待作業結束 */
  public async CancelRun(jobId: string): Promise<any> {
    return await this.api.post(`Run/${jobId}/Cancel`, {}, false).toPromise();
  } 

  /** 取得申報3-3 */
  public async Ana33(clinicId: number, declareMonth: string, declareClass: string, connId: string, amendNum: string, opt: string): Promise<any> {
    return await this.api.get('Ana33', {
      clinicId: clinicId,
      date: declareMonth,
      declareClass: declareClass,
      connectionId: connId,
      amendNum: amendNum,
      opt: opt,
    }).toPromise();
  }

  /** 取得核對申報資料 */
  public async GetDeclareCheckPage(clinicId: number, declareMonth: string, pageSize: number, pageNumber: number, queryList: DeclareCheckFilterDTO[], getDDL: boolean, amendNum: string, orderBy: string, orderByDesc: boolean): Promise<DeclareChecViewDTO> {
    var model = new DeclareCheckQueryDTO;
    model.ClinicId = clinicId;
    model.Date = declareMonth;
    model.PageSize = pageSize;
    model.PageNumber = pageNumber;
    model.QueryList = queryList;
    model.GetDDL = getDDL;
    model.AmendNum = amendNum;
    model.OrderBy = orderBy;
    model.OrderByDesc = orderByDesc;
    var data = await this.api.put('GetDeclareCheckPage', model).toPromise<DeclareChecViewDTO>();
    return data;
  }

  /** 取得門診申報xml資料 */
  public async GetOPDxmlData(clinicId: number, declareMonth: string, declareWay: number, declareType: number, isUploadApi: boolean, connectionId: string, amendNum: string): Promise<OPDxmlDataDTO> {
    var data = await this.api.get('GetOPDxmlData', {
      clinicId: clinicId,
      declareMonth: declareMonth,
      declareWay: declareWay,
      declareType: declareType,
      connectionId: connectionId,
      isUploadApi: isUploadApi,
      amendNum: amendNum
    }).toPromise<OPDxmlDataDTO>();
    return data;
  }

  /** 藥局申報比對 */
  public async GetPharComparison(clinicId: number, declareMonth: string, reportType: string, showMode: string, orderMode: string, pharid: number): Promise<PharComparisonDto[]> {
    return await this.api.get('GetPharComparison', {
      clinicId,
      declareMonth,
      reportType,
      showMode,
      orderMode,
      pharid
    }).toPromise<PharComparisonDto[]>();
  }

  public async CreateNHIDownloadRequest(clinicId: number, typeCode: string, declareMonth: string, localId: string, nhiId: string, queryFileName: string): Promise<void> {
    await this.api.get('CreateNHIDownloadRequest', {
      clinicId: clinicId,
      typeCode,
      declareMonth: declareMonth,
      localId, nhiId, queryFileName
    }).toPromise<void>();
  }

  public async NHISendRequest(clinicId: number, typeCode: string, path: string, localId: string, nhiId: string): Promise<void> {
    await this.api.post('NHISendRequest', {
      clinicId: clinicId,
      typeCode,
      path,
      localId, nhiId
    }).toPromise<void>();
  }

  public async GetNHISendRequest(clinicId: number): Promise<NHISendRequestDTO[]> {
    return await this.api.get('GetNHISend', {
      clinicId: clinicId
    }).toPromise<NHISendRequestDTO[]>();
  }
  public async CheckNHISend(clinicId: number, fileName: string): Promise<boolean> {
    return await this.api.get('CheckNHISend', {
      clinicId: clinicId,
      fileName
    }).toPromise<boolean>();
  }
  public async GetNHIDownloadRequest(clinicId: number): Promise<NHIDownloadRequestDTO[]> {
    return await this.api.get('GetNHIDownloadRequest', {
      clinicId: clinicId
    }).toPromise<NHIDownloadRequestDTO[]>();
  }

  public async GetDeclareResult(clinicId: number, declareMonth: string, includeCC: boolean, ccFirst: boolean, includeVt: boolean,
    includeRemark: boolean, connectionId: string,rxName: number, amendNum: string): Promise<OPDxmlDataDTO> {
    var data = await this.api.get('GetDeclareResult', {
      clinicId: clinicId,
      declareMonth: declareMonth,
      includeCC: includeCC,
      ccFirst: ccFirst,
      includeVt: includeVt,
      includeRemark: includeRemark,
      connectionId: connectionId,
      rxName: rxName,
      amendNum: amendNum,
    }).toPromise<OPDxmlDataDTO>();
    return data;
  }

  public async GetFilteredDeclareResult(request: DeclareSampleReviewRequestDTO): Promise<DeclareSampleReviewResultDTO> {
    return await this.api.post('GetFilteredDeclareResult', request).toPromise<DeclareSampleReviewResultDTO>();
  }

  /** 取得申報錯誤訊息資料 */
  public async GetDeclareErrTable(clinicId: number, declareMonth: string, amendNum: string, groupType: number, orderBy: string, orderByDesc: boolean): Promise<any> {
    var data = await this.api.get('GetDeclareErrTable', { clinicId: clinicId, declareMonth: declareMonth, amendNum: amendNum, type: groupType, orderBy: orderBy, orderByDesc: orderByDesc}).toPromise<any>();
    return data;
  }

  /** 取得最近一筆參數設定+檢查申報H10,H11,H12 的Azure Table Stroage是否存在 */
  public async GetLastParamAndCheckTable(clinicId: number, month: string, type: number, amenNum: string): Promise<ParamSetAndCheckTableDto> {
    var data = await this.api.get('GetLastParamAndCheckTable', { clinicId: clinicId, month: month, type: type, amenNum }).toPromise<ParamSetAndCheckTableDto>();
    return data;
  }

  public async CheckDeclareXmlLog(clinicId: number, declareMonth: string, isAmend: boolean): Promise<boolean> {
    var data = await this.api.get('CheckDeclareXmlLog', { clinicId: clinicId, declareMonth: declareMonth, isAmend }).toPromise<boolean>();
    return data;
  }

  public async DeleteDeclareXmlLog(clinicId: number, declareMonth: string): Promise<boolean> {
    var data = await this.api.get('DeleteDeclareXmlLog', { clinicId: clinicId, declareMonth: declareMonth }).toPromise<boolean>();
    return data;
  }

  /** 取得門診申報總表 報表資料 */
  public async GetOpdDeclareReport(clinicId: number, declareMonth: any, amendNum: string): Promise<OpdDeclareReportDTO> {
    var data = await this.api.get('GetOpdDeclareReport', { clinicId: clinicId, declareMonth: this.onGetDateString(declareMonth), amendNum: amendNum }).toPromise<OpdDeclareReportDTO>();
    return data;
  }

  /** 取得門診申報總表 報表資料 */
  public async GetDeclareCaseReport(clinicId: number, declareMonth: any, isByDoctor: boolean): Promise<DeclareCaseReportPageDTO[]> {
    var data = await this.api.get('GetDeclareCaseReport', { clinicId: clinicId, declareMonth: this.onGetDateString(declareMonth), isByDoctor: isByDoctor }).toPromise<DeclareCaseReportPageDTO[]>();
    return data;
  }

  /** 醫師分診別金額統計 報表資料 */
  public async GetDoctorRoomcodeDeclareReport(clinicId: number, startTime: any, endTime: any, doctorType: number, isCaseGroup: boolean, isShowTotal: boolean): Promise<DeclareCaseReportDTO[]> {
    var data = await this.api.get('GetDoctorRoomcodeDeclareReport', { clinicId: clinicId, startTime: this.onGetDateString(startTime), endTime: this.onGetDateString(endTime), doctorType: doctorType, isCaseGroup: isCaseGroup, isShowTotal: isShowTotal }).toPromise<DeclareCaseReportDTO[]>();
    return data;
  }

  /** 期間耗用量統計 報表資料 */
  public async GetPeriodUsageDeclareReport(clinicId: number, doctorId: number, query: DeclarePeriodUsageQueryDTO): Promise<DeclarePeriodUsageReportDTO[]> {
    var data = await this.api.get('GetPeriodUsageDeclareReport', { clinicId: clinicId, doctorId: doctorId, startDate: query.StartDate, endDate: query.EndDate, includeHRx: query.IncludeHRx, includeOtherSales: query.IncludeOtherSales, rxCode: query.RxCode, stdCode: query.StdCode, dispType: query.DispType, nhiDrugType: query.NhiDrugType, sortBy: query.SortBy, reportType: query.ReportType }).toPromise<DeclarePeriodUsageReportDTO[]>();
    return data;
  }

  /** 醫師藥用-分類統計 報表資料 */
  public async GetRxCategoryReport(clinicId: number, doctorId: number, query: DeclareRxCategoryQueryDTO): Promise<DeclareRxCategoryReportDTO[]> {
    var data = await this.api.get('GetRxCategoryReport', { clinicId: clinicId, doctorId: doctorId, startDate: query.StartDate, endDate: query.EndDate, rxCode: query.RxCode, stdCode: query.StdCode, roomCode: query.RoomCode, nhiDrugTypes: query.NhiDrugTypes, sortBy: query.SortBy, reportType: query.ReportType, excludeNonNhi: query.ExcludeNonNhi ?? false }).toPromise<DeclareRxCategoryReportDTO[]>();
    return data;
  }
  /** 就診比率與日均藥費統計 報表資料 */
  public async GetVisitsRatioMedcostDeclareReport(clinicId: number, startDate: any, endDate: any): Promise<GetVisitsRatioMedcostReportDTO[]> {
    var data = await this.api.get('GetVisitsRatioMedcostDeclareReport', { clinicId: clinicId, startDate: this.onGetDateString(startDate), endDate: this.onGetDateString(endDate) }).toPromise<GetVisitsRatioMedcostReportDTO[]>();
    return data;
  }

  /** 身心科期間人均治療費統計 報表資料 */
  public async GetPeriodTreatFeeDeclareReport(clinicId: number, startDate: any, endDate: any): Promise<GetPeriodTreatFeeReportDTO[]> {
    var data = await this.api.get('GetPeriodTreatFeeDeclareReport', { clinicId: clinicId, startDate: this.onGetDateString(startDate), endDate: this.onGetDateString(endDate) }).toPromise<GetPeriodTreatFeeReportDTO[]>();
    return data;
  }

  /** 藥師調劑明細表 - 明細 (依藥師分組) */
  public async GetPharmacistDispenseDetail(clinicId: number, startDate: any, endDate: any, periods: number[], fileType: number): Promise<PharmDispDetailGroupDto[]> {
    var data = await this.api.get('GetPharmacistDispenseDetail', {
      clinicId: clinicId,
      startDate: this.onGetDateString(startDate),
      endDate: this.onGetDateString(endDate),
      periods: (periods ?? []).join(','),
      fileType: fileType,
    }).toPromise<PharmDispDetailGroupDto[]>();
    return data;
  }

  /** 藥師調劑明細表 - 合計統計 (依藥師分組) */
  public async GetPharmacistDispenseSummary(clinicId: number, startDate: any, endDate: any, periods: number[], fileType: number): Promise<PharmDispSummaryGroupDto[]> {
    var data = await this.api.get('GetPharmacistDispenseSummary', {
      clinicId: clinicId,
      startDate: this.onGetDateString(startDate),
      endDate: this.onGetDateString(endDate),
      periods: (periods ?? []).join(','),
      fileType: fileType,
    }).toPromise<PharmDispSummaryGroupDto[]>();
    return data;
  }

  /** 取得健保申報明細摘要表 報表資料 */
  public async GetOpdDeclareDetailsRpt(clinicId: number, declareMonth: any, amenNum: string): Promise<OpdDeclareDetailsRptDTO[]> {
    var data = await this.api.get('GetOpdDeclareDetailsRpt', { clinicId: clinicId, declareMonth: this.onGetDateString(declareMonth), amendNum: amenNum }).toPromise<OpdDeclareDetailsRptDTO[]>();
    return data;
  }

  /** 取得健保申報完整明細 資料 (代申報輔助使用) */
  public async GetOpdFullDeclareDetails(clinicId: number, declareMonth: any, amenNum: string): Promise<OpdDeclareFullDetailsDTO[]> {
    var data = await this.api.get('GetOpdDeclareFullDetails', { clinicId: clinicId, declareMonth: this.onGetDateString(declareMonth), amendNum: amenNum }).toPromise<OpdDeclareFullDetailsDTO[]>();
    return data;
  }

  /** 健保申報完整明細 匯出Excel檔案 (代申報輔助使用) */
  public async GenDeclareFullDetailsExcel(clinicId: number, declareMonth: any, amenNum: string): Promise<boolean> {
    let isOk = false;
    await this.api.getFile('GenDeclareFullDetailsExcel', { clinicId: clinicId, declareMonth: this.onGetDateString(declareMonth), amendNum: amenNum }).toPromise()
      .then(value => {
        let blob = new Blob([value], { type: 'application/vnd.ms-excel' });
        let folder = "健保申報核對資料";
        let clinicCode = UserCache.getLoginUser().Clinic.Code;
        let clinicName = UserCache.getLoginUser().Clinic.Name;
        let fileName = this.onGetDateString(declareMonth, true, '', true) + '_' + folder + '_' + clinicCode + clinicName + '_' + this.onGetDateString(new Date(), false, '', false) + DateHelper.getTimeString(new Date(), '', true) + `.xls`;

        this.hcrService.SaveBlobAs((folder + '_' + clinicCode) + "\\" + fileName, blob);
        isOk = true;
      })
      .catch(reason => {
        isOk = false;
      });

    return isOk;
  }

  public async GetExecuteTimeReport(clinicId: number, yearMonth: Date, defMins: number): Promise<any> {
    var data = await this.api.get('GetExecuteTimeReport', { clinicId: clinicId, yearMonth: this.onGetDateString(yearMonth), defMins: defMins }).toPromise<any>();
    return data;
  }

  public async GetDeclareList(clinicId: number, declareMonth: Date): Promise<AmendGridViewModel[]> {
    var data = await this.api.get('GetDeclareList', {
      clinicId: clinicId,
      declareMonth: declareMonth.toLocaleDateString()
    }).toPromise<AmendGridViewModel[]>();
    return data;
  }

  public async GetAmendDeclareList(clinicId: number, declareMonth: Date, addApply: string): Promise<AmendGridViewModel[]> {
    var data = await this.api.get('GetAmendDeclareList', {
      clinicId: clinicId,
      declareMonth: declareMonth.toLocaleDateString(),
      addApply: addApply
    }).toPromise<AmendGridViewModel[]>();
    return data;
  }

  public async UpdateAddApply(clinicId: number, ids: number[], addApply: string | ''): Promise<void> {
    await this.api.post('UpdateAddApply', {
      ClinicId: clinicId,
      DeclareIds: ids,
      AddApply: addApply
    }).toPromise<void>();

  }
  /** 取同療程次數月報表之資料 */
  public async GetSameTreatPerMonthList(declareMonth: Date, cusTp: string, pageRow: number): Promise<SameTreatPerMonthListDTO[]> {
    var data = await this.api.get('GetSameTreatPerMonthList', { cusTp: cusTp, declareMonth: declareMonth.toLocaleDateString(), pageRow: pageRow }).toPromise<SameTreatPerMonthListDTO[]>();
    return data;
  }

  /** 檢查是否有同療併入本月/保留下月 */
  public async CheckSameCusTP(clinicId: number, declareMonth: any, amenNum: string): Promise<SameCusTPCheckDTO> {
    var data = await this.api.get('CheckSameCusTP', { clinicId: clinicId, declareMonth: this.onGetDateString(declareMonth), amendNum: amenNum }).toPromise<SameCusTPCheckDTO>();
    return data;
  }

  /** 取得同療併入本月/保留下月 - 申報檔3L
   * @param clinicId 診所Id
   * @param declareMonth 申報月份
   * @param amenNum 若是補報要傳入第x次補報  " "代表一般申報  Y代表全部(機率低，但保留彈性，含這個月全部不管3L是否有補報Flag)
   * @param type 類別：1:同療合併入本月  2:同療保留至下月
  */
  public async GetSameCusTP3LData(clinicId: number, declareMonth: any, amenNum: string, type: number, pageSize: number, pageNumber: number, name: string, patinetNo: string, queryDate: any): Promise<any> {
    var query = {
      clinicId: clinicId,
      declareMonth: this.onGetDateString(declareMonth),
      type: type,
      amendNum: amenNum,
      pageSize: pageSize,
      pageNumber: pageNumber,
      name: name,
      patinetNo: patinetNo,
      queryDate: queryDate ? this.onGetDateString(queryDate) : null,
    };
    var data = await this.api.get('GetSameCusTP3LData', query).toPromise<any>();
    return data;
  }

  /** 轉換Date To String
  *  [參數] ev:值，isRoc:是否轉換成民國年，symbol:分隔符號，isMonth:是否只顯示到月份
  */
  private onGetDateString(ev, isRoc: boolean = false, symbol = '/', isMonth = false) {
    if (ev) {
      var d = new Date(ev);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = isRoc ? (d.getFullYear() - 1911) : d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      if (isMonth) {
        return [year, month].join(symbol);
      } else {
        return [year, month, day].join(symbol);
      }
    }
  }

  /** 轉換Time To String
*  [參數] ev:值，isRoc:是否轉換成民國年，symbol:分隔符號，isMonth:是否只顯示到月份
*/
  private onGetTimeString(ev, timeSymbol = ':') {
    if (ev) {
      var d = new Date(ev);
      // 趕時間先簡單寫
      let hr = d.getHours().toString();
      if (d.getHours() < 10) {
        hr = '0' + hr;
      }
      let min = d.getMinutes().toString();
      if (d.getMinutes() < 10) {
        min = '0' + min;
      }
      let sec = d.getSeconds().toString();
      if (d.getSeconds() < 10) {
        sec = '0' + sec;
      }
      var timeStr = [hr, min, sec].join(timeSymbol);
      return timeStr;
    }
  }
}
